import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { request } from 'utilities/graph';
import { getUploadedOrdersByClientByCreatedAt } from 'graphql/queries';
import { TIME_ZONE } from '@silvergatedelivery/constants';

const useStyles = makeStyles((theme) => ({
  dateTimeCell: {
    minWidth: '70px',
  },
  fileNameCell: {
    maxWidth: '200px',
    wordWrap: 'break-word',
  },
  emailCell: {
    maxWidth: '140px',
    wordWrap: 'break-word',
  },
}));

export default function UploadHistoryTable({ clientId }) {
  const classes = useStyles();
  const [uploadHistory, setUploadHistory] = useState([]);

  useEffect(() => {
    if (clientId) {
      (async () => {
        const { data: { getUploadedOrdersByClientByCreatedAt: { items } } } = await request(getUploadedOrdersByClientByCreatedAt, {
          clientId,
          sortDirection: 'DESC',
          limit: 20,
        });
        setUploadHistory(items);
      })();
    }
  }, [clientId]);

  return (
    <>
      <Typography variant="h6" style={{ margin: 10 }}>
        訂單上傳紀錄
      </Typography>
      <TableContainer component={Paper} style={{ marginLeft: 20 }}>
        <Table aria-label="upload history table">
          <TableHead>
            <TableRow>
              <TableCell className={classes.dateTimeCell}>上傳時間</TableCell>
              <TableCell>檔名</TableCell>
              <TableCell>訂單數量</TableCell>
              <TableCell>使用者</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {uploadHistory.map((row) => (
              <TableRow key={row.id}>
                <TableCell>{moment(row.createdAt).tz(TIME_ZONE).format('MM-DD HH:mm')}</TableCell>
                <TableCell className={classes.fileNameCell}>{row.fileName}</TableCell>
                <TableCell>{row.orderIds.length}</TableCell>
                <TableCell className={classes.emailCell}>{row.createdBy}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}

UploadHistoryTable.propTypes = {
  clientId: PropTypes.string,
};
